module.exports = __webpack_public_path__ + "static/media/1022736.aed6d454.jpg";